export const carAssignmentMA = () =>
  import(/* webpackChunkName: "massachusetts-car-assignment" */ './ma/ma-car-assignment.js');
export const carAssignmentVA = () =>
  import(/* webpackChunkName: "virginia-car-assignment" */ './default/default-car-assignment.js');
export const carAssignmentVT = () =>
  import(/* webpackChunkName: "vermont-car-assignment" */ './default/default-car-assignment.js');
